module.exports = __webpack_public_path__ + "static/media/Portrait-10025.36e0642f.jpg";